export default "__VITE_ASSET__Kb8lO390__"